import ObjectCreationValidator from '@/entities/validators/ObjectCreationValidator'
import {
  DeclinedTransactionItemI,
  InvoiceBodyI,
  InvoiceItemI,
  TransactionItemI,
} from '@/modules/invoice/types/api/InvoiceItem'
import { ClientDetailI } from '../types/api/InvoiceItem'

export default class InvoiceItem {
  ab_invoice_type: string
  serviceId: string
  serviceType: string
  date: string
  duedate: string
  status: string
  paymentmethod: string
  invoicenum: string
  invoiceid: number | null
  subtotal: string
  total: string
  balance: string
  credit: string
  taxrate: string
  tax: string
  reverse_payment: string
  indicated_taxed_items: string
  massPayInvoice: boolean
  items: InvoiceBodyI[]
  transactions: TransactionItemI[]
  declinedTransactionsInfo: DeclinedTransactionItemI[]
  downgradeItems: object | null
  type: string
  paymentmethodName: string
  'client-details': ClientDetailI

  constructor(invoice: InvoiceItemI) {
    this.ab_invoice_type = invoice.ab_invoice_type ?? ''
    this.serviceId = invoice.serviceId ?? ''
    this.serviceType = invoice.serviceType ?? ''
    this.date = invoice.date
    this.duedate = invoice.duedate
    this.status = invoice.status
    this.paymentmethod = invoice.paymentmethod
    this.invoicenum = invoice.invoicenum
    this.invoiceid = invoice.invoiceid ?? null
    this.subtotal = invoice.subtotal
    this.total = invoice.total
    this.balance = invoice.balance
    this.credit = invoice.credit
    this.massPayInvoice = invoice.massPayInvoice ? invoice.massPayInvoice : false
    this.taxrate = parseFloat(invoice.taxrate).toString()
    this.tax = invoice.tax
    this.reverse_payment = invoice.reverse_payment ?? ''
    this.indicated_taxed_items = invoice.indicated_taxed_items ?? ''
    this.items = invoice.items ?? []
    this.transactions = invoice.transactions ? invoice.transactions : []
    this.declinedTransactionsInfo = invoice.declinedTransactionsInfo ? invoice.declinedTransactionsInfo : []
    this.downgradeItems = invoice.downgradeItems ? invoice.downgradeItems : []
    this.type = invoice.type ? invoice.type : ''
    this.paymentmethodName = invoice.paymentmethodName ? invoice.paymentmethodName : ''
    this['client-details'] = invoice['client-details'] ?? {
      firstname: '',
      lastname: '',
      fullname: '',
      companyname: '',
      email: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      postcode: '',
      countrycode: '',
      phonenumber: '',
      tax_id: '',
      cctype: '',
      cclastfour: '',
      taxexempt: false,
    }

    ObjectCreationValidator.validate(this)
  }
}
